export const dayNames = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const formatTime = (time: string): string => {
  if (!time || time.length !== 4) return time;
  const hours = parseInt(time.substring(0, 2));
  const minutes = time.substring(2, 4);
  const ampm = hours >= 12 ? "PM" : "AM";
  const displayHours = hours % 12 || 12;
  return `${displayHours}:${minutes} ${ampm}`;
};

export const createDefaultOpeningHours = (dayIndex: number) => ({
  open: { day: dayIndex, time: "0900" },
  close: { day: dayIndex, time: "1700" },
});

export const ensureOpeningHoursArray = (openingHours: any[], length = 7) => {
  const hours = Array.isArray(openingHours) ? [...openingHours] : [];
  while (hours.length < length) {
    hours.push(createDefaultOpeningHours(hours.length));
  }
  return hours;
};
